import { SvgIcon, theme } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { IconKey } from '@salecycle/ui-component-library/SvgIcons/svgIconsParams';
import { SelectCard } from 'sections/onsite-campaigns/pages/CampaignEditor/components/SelectCard';

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Title = styled.div`
  margin-left: ${({ theme }) => theme.designToken.spacing2};
  font: ${({ theme }) => theme.designToken.headingH3};
  color: ${({ theme }) => theme.designToken.neutral900};
`;

const Body = styled.div`
  font: ${({ theme }) => theme.designToken.body2};
  color: ${({ theme }) => theme.designToken.neutral700};
  margin-top: ${({ theme }) => theme.designToken.spacing2};
  z-index: 9;
  position: relative;
`;

export interface TriggerDrawerProps {
  icon: IconKey;
  title: string;
  description: string;
}

export const TriggerEventCard = ({ icon, title, description }: TriggerDrawerProps) => {
  return (
    <SelectCard selected>
      <Header>
        <SvgIcon size="24" name={icon} color={theme.designToken.neutral700} />
        <Title>{title}</Title>
      </Header>
      <Body>{description}</Body>
    </SelectCard>
  );
};
